export type KaliaCalendarConfig = {
    slotDuration: number;
    slotMinTime: string;
    slotMaxTime: string;
    minColumnWidth: number;
    slotHeight: number;
    timezone: string;
};

export type KaliaResource = {
    id: string;
    title: string;
    order: number;
};

export type KaliaEvent = {
    id: string;
    resourceIds: string[];
    start: Date;
    end: Date;
    title: string;
    color?: string;
    display?: 'background';
    className?: string;
    metadata?: Record<string, any>;
};

export type PositionedEvent = KaliaEvent & {
    top: number;
    height: number;
    lane: number;
    totalLanes: number;
};

export const DEFAULT_CONFIG: KaliaCalendarConfig = {
    slotDuration: 30,
    slotMinTime: '07:00',
    slotMaxTime: '21:00',
    minColumnWidth: 180,
    slotHeight: 40,
    timezone: 'Europe/Berlin',
};
